export default function getResource(label) {
    const resources = {
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        email: 'Adresse courriel',
        saveContinue: 'Enregistrer et continuer',
        change: 'Modifier',
        pickupInfoIncompleteError: 'Veuillez fournir les renseignements sur le ramassage.',
        pickupInfoUnsavedError: 'Veuillez confirmer les renseignements sur le ramassage.'
    };

    return resources[label];
}
